import React, { useEffect } from "react";

// Markdown & Plugins
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import toc from "remark-toc";
import images from "remark-images";
import gemoji from "remark-gemoji";
import highlight from "remark-highlight.js";
import hint from "remark-hint";

import components from "./components/oembed.component";

import math from "remark-math";
import katex from "rehype-katex";
import rehypeRaw from "rehype-raw";

import $ from "jquery";

import "./katex.min.css";

export default function MarkdownDisplay(props) {
  console.log("Markdown-Input:", JSON.stringify(props?.content));
  if (!props?.content || typeof props.content !== "string") {
    console.error("Ungültiger oder leerer Content:", props?.content);
  }

  useEffect(() => {
    $("span.katex-error").each(function () {
      const error = $(this).attr("title");
      $(this).text(error);
    });
  }, [props.content]);

  return (
    <div
      className={`${
        props.className ? props.className + " " : ""
      }markdown-container`}
    >
      <ReactMarkdown
        components={components}
        remarkPlugins={[
          [math, { singleDollar: false }],
          highlight,
          gfm,
          toc,
          images,
          gemoji,
          hint,
        ]}
        children={props?.content || ""}
      />
    </div>
  );
}
